module.exports = __webpack_public_path__ + "img/articles2.jpg?bb7f1d2c7409eee4231421fa06398393";